import CONSTANTS from '../../constants';

export const KEYCLOAK_CONFIG = {
  url: CONSTANTS.ENV.KEYCLOAK_URL,
  clientId: CONSTANTS.ENV.KEYCLOAK_CLIENT_ID,
  realm: CONSTANTS.ENV.KEYCLOAK_REALM,
};
